// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase:{
    apiKey: "AIzaSyBnSkTNdN_AuDtSnqf1w2mkRAuCRDeFPjs",
    authDomain: "mati-9b7e9.firebaseapp.com",
    projectId: "mati-9b7e9",
    storageBucket: "mati-9b7e9.appspot.com",
    messagingSenderId: "918291439887",
    appId: "1:918291439887:web:ce3034e0fd4d16a9175e7a",
    measurementId: "G-DN9R5TQX4R"
  },
  baseUrl:'https://devapimatisuperadmin.maticarbon.com',
  forgetPasswordUrl:'https://matisuperadmin.maticarbon.com/auth/forget-password'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
